var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom"},[_c('NativeCustom',{on:{"onKeydown":_vm.onKeydown},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }